import * as React from 'react'
import { connect } from 'react-redux'
import * as ReactStrap from 'reactstrap'
import * as App from '../../app'
import * as Image from '../../components/image'
import { Loading } from '../../components/loading'
import * as RasaInput from '../../components/rasa-input'
import * as Config from '../../config'
import * as RootConstants from '../../constants'
import './styles.css'

interface Props {
  apiOrigin: string,
  fieldChangeAction: any,
  imageUrl: string,
  label?: string,
  placeholder?: string,
  required?: boolean,
  selectedCommunity: string,
  title?: string,
}

interface State { image_upload_in_progress: boolean, errorMessage: string }

class ImageUploadClass extends React.Component<any, State> {
  constructor(props: Props) {
    super(props);
    this.state = { errorMessage: '', image_upload_in_progress: false }
  }

  public handleImageUpload = (community: string, imageData: Image.ModalImageData) => {
    this.setState({ errorMessage: '', image_upload_in_progress: true });
    const payload = {
      content: imageData.content,
      name: imageData.name,
      partnerCode: imageData.partnerCode,
      rowId: imageData.rowId,
    };
    const requestHeaders: HeadersInit = {
      'Authorization': 'Bearer ' + localStorage.getItem(RootConstants.ACCESS_TOKEN),
      'Content-Type': 'application/json',
    }
    try {
      fetch(`${this.props.props.apiOrigin}${Image.IMAGE_IMPORT_SERVER_RESOURCE}/${community}`,
        {
          body: JSON.stringify(payload),
          cache: 'no-cache',
          headers: requestHeaders,
          method: 'POST',
        },
      ).then((response) => {
        response.json().then((jsonResponse) => {
          if (response.status === 200) {
            this.props.props.fieldChangeAction(jsonResponse.image_url);
          } else {
            this.setState({ errorMessage: 'Error occured while uploading image' });
          }
          this.setState({ image_upload_in_progress: false });
        })
      })
    } catch (error) {
      this.setState({ errorMessage: error, image_upload_in_progress: false });
    }
  }

  public render() {
    return (
      <div className="image-upload">
        <div className="image-upload-url-div">
          <RasaInput.RasaInput label={this.props.props.label || 'Image URL'}
            placeholder={this.props.props.placeholder || 'Enter image url or upload an image'}
            value={this.props.props.imageUrl}
            validation={this.props.props.required ? RasaInput.validateForgivingUrl(this.props.props.imageUrl)
              : RasaInput.validateOptionalForgivingUrl(this.props.props.imageUrl)}
            onChange={(e: any) => this.props.props.fieldChangeAction(e.target.value)}
          />
        </div>
        <div className="image-upload-input-file-div">
          <ReactStrap.Input id="upload-image-input"
            className="image-upload-url-input-file" type="file" accept="image/*"
            onChange={(e) => Image.handleImageSelection(this.props.props.selectedCommunity, e.target.files,
              this.handleImageUpload)} />
          {this.state.image_upload_in_progress ? <Loading size={Loading.Sizes.SMALL} /> :
            <ReactStrap.Label htmlFor="upload-image-input" title={this.props.props.title || 'Upload Image'}>
              <div>
                <div><i className="fas fa-file-upload image-upload-icon"></i></div>
              </div>
            </ReactStrap.Label>
          }
        </div>
        {this.state.errorMessage && <div><span className="alert-danger">{this.state.errorMessage}</span></div>}
      </div>
    )
  }
}

const ImageUploadComponent = (props: Props) => <div>
  <ImageUploadClass props={props} />
</div>

export const ImageUpload = connect(
  ({ app, config }: App.WrappedState & Config.WrappedState) =>
    ({ apiOrigin: config.api.origin, selectedCommunity: app.selectedCommunity }),
)(ImageUploadComponent)



// WEBPACK FOOTER //
// ./src/components/image-upload/image-upload.tsx